import React, { forwardRef } from 'react';
import c from 'classnames';

import BaseIconButton from '../BaseIconButton';
import { IconButtonProps } from './types';
import {
  getIconButtonColorClasses,
  ICON_BUTTON_ICON_SIZE_CLASSES,
  ICON_BUTTON_SHAPE_CLASSES,
  ICON_BUTTON_SIZE_CLASSES,
} from './utils';

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const {
    appearance = 'secondary',
    children,
    className,
    Icon,
    shape = 'pill',
    size = 's',
    variant = 'ghost',
    ...rest
  } = props;

  const sizeClassName = ICON_BUTTON_SIZE_CLASSES[size];
  const shapeClassName = ICON_BUTTON_SHAPE_CLASSES[shape];
  const iconSizeClassName = ICON_BUTTON_ICON_SIZE_CLASSES[size];

  const colorClassName = getIconButtonColorClasses({ appearance, variant });

  return (
    <BaseIconButton
      ref={ref}
      className={c('p-0', className, sizeClassName, shapeClassName, colorClassName)}
      {...rest}>
      {Icon ? <Icon className={iconSizeClassName} /> : children}
    </BaseIconButton>
  );
});

export default IconButton;
